import { leftPad } from '../../utils';
/**
 * Parses a string in format "01:23:45.678" to a number, representing the milliseconds value.
 *
 * @param input - string in format "01:23:45.678"
 * @returns time mark as a number
 */
export function parseTimeMark(input: string): number {
    const split = input.split(':');
    if (split.length !== 3) {
        throw new Error(`Does not appear to be a valid time mark: ${input}`);
    }
    const hours = parseInt(split[0], 10);
    const minutes = parseInt(split[1], 10);
    const [seconds, milliseconds] = split[2].split('.').map(vv => parseInt(vv, 10));
    return milliseconds + seconds * 1000 + minutes * 60 * 1000 + hours * 60 * 60 * 1000;
}

export function formatTimeMark(input: number): string {
    const milliseconds = input % 1000;
    const seconds = Math.floor((input / 1000) % 60);
    const minutes = Math.floor((input / 1000 / 60) % 60);
    const hours = Math.floor(input / 1000 / 60 / 60);
    return `${leftPad(hours, 2)}:${leftPad(minutes, 2)}:${leftPad(seconds, 2)}.${leftPad(milliseconds, 3)}`;
}
